import * as React from "react";

import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import ClientMypageMainPasswordForm from "./password_update/client_mypage_main_password_form";

interface IProps {
  isLoading: boolean;
  handleUpdatePasswordSubmit: (values: any) => void;
}

const ClientMyPagePasswordUpdateComponent: React.FC<IProps> = (props) => {
  const { isLoading, handleUpdatePasswordSubmit } = props;

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    routeConfig.clientMypage,
    routeConfig.clientMypagePasswordUpdate,
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}

      <PageWrapper>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <Breadcrumbs breadcrumbItems={breadcrumbItems} />
          <ClientMypageMainPasswordForm
            onSubmit={handleUpdatePasswordSubmit}
            enableReinitialize={true}
          />
        </div>
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientMyPagePasswordUpdateComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/client_mypage_password_update.tsx